import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogEnabled, datadogApplicationId, datadogClientToken, stage } from '../config/baseConfig';

const DATADOG_SITE = 'datadoghq.com';
const DATADOG_SERVICE = 'takuty-entry-screen';

class Datadog {
  private static initialized: boolean = false;

  static startMonitoring(): void {
    // 本番環境（ビルド成果物）以外では一切初期化しない
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    if (!datadogEnabled || Datadog.initialized) {
      return;
    }

    // 認証情報がプレースホルダーのまま残っている場合は初期化しない
    if (
      !datadogApplicationId ||
      datadogApplicationId.startsWith('REPLACE_') ||
      !datadogClientToken ||
      datadogClientToken.startsWith('REPLACE_')
    ) {
      return;
    }

    datadogRum.init({
      applicationId: datadogApplicationId,
      clientToken: datadogClientToken,
      site: DATADOG_SITE,
      service: DATADOG_SERVICE,
      env: stage,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input'
    });

    datadogLogs.init({
      clientToken: datadogClientToken,
      site: DATADOG_SITE,
      service: DATADOG_SERVICE,
      env: stage,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100
    });

    Datadog.initialized = true;
  }
}

export default Datadog;
